module.exports = __webpack_public_path__ + "static/media/Asset 4Left Knee.85e032b5.png";